import { render, staticRenderFns } from "./Kemajuan.vue?vue&type=template&id=e24af980"
import script from "./Kemajuan.vue?vue&type=script&lang=js"
export * from "./Kemajuan.vue?vue&type=script&lang=js"
import style0 from "./Kemajuan.vue?vue&type=style&index=0&id=e24af980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports